import React, { Component } from 'react';
//import loading from '../../Images/Daikin_Images/daikin50.gif';
import loading from '../../Images/loading2_invert_colours.gif';

export default class Launch_Screen extends Component {
	constructor(props) {
		super(props);

		this.state = {
			show_img: true,
		}

		setTimeout(this.getKeyPair, 2000);
		setTimeout(this.handleTimeOut, 6000);
	}

	getKeyPair = () => {
		this.props.receiver.getRSAKeyPair();
	}

	handleTimeOut = () => {
		this.props.content_handler('Select_Language');
	}

	render() {
		/*let img_width = this.props.width*0.8;
		let img_height = img_width*0.56;
		if(img_height>this.props.height){
			img_width = (this.props.height/56*100);
			img_height = img_width*0.56;
		}*/
		let img_width = this.props.width * 0.2;
		if (img_width > 100) img_width = 100;
		let img_height = img_width;

		let border_radius = img_width / 2;

		let margin_top = (this.props.height - img_height) / 2;
		if (margin_top < 0) margin_top = 0;

		return (
			<div style={{ height: this.props.height, width: this.props.width, textAlign: 'center' }} >
				<div id='animation' className='fadeIn' style={{ display: this.state.show_img ? 'block' : 'none' }}>
					<img src={loading} style={{ width: img_width, marginTop: margin_top, borderRadius: border_radius }} />
				</div>
			</div>
		)
	}
}


